// extracted by mini-css-extract-plugin
export default {"libraryContainer":"library_libraryContainer__46YEk","linkUl":"library_linkUl__ETat6","modalContainer":"library_modalContainer__JKhpb","textInModal":"library_textInModal__WfCD8"};